module.exports = __webpack_public_path__ + "static/media/Certificate1.261b0c8d.png";